import React from "react";
import { Icon, Toast, Result } from "antd-mobile";
import "./MyInterviews.scss";
import http from "../../util/api";
import GoBack from "../../components/GoBack";
import withAuth from "../../HOCs/withAuth";

// const resid = "617278498676";
const resid = 617650062980;

class MyInterviews extends React.Component {
  state = {
    myInterviews: [] //求职记录列表
  };

  async componentDidMount() {
    Toast.loading("loading...", 0);
    this.setState({ loading: true });
    window.V5CHAT("hideBtn");
    await this.getInterviewDetail();
    this.setState({ loading: false });
  }

  getInterviewDetail = async () => {
    try {
      let res = await http().getTable({
        resid
      });
      let { data } = res;
      if (data.data.length) {
        this.setState({ myInterviews: data.data });
      }
      Toast.hide();
    } catch (error) {
      console.log(error);
      Toast.fail(error.message);
    }
  };

  goBack = () => {
    this.props.history.push("/personal_center");
  };

  renderCard(interviewDetail) {
    return (
      <div
        className="my_interview_card"
        key={interviewDetail.REC_ID}
        onClick={() => {
          if (interviewDetail.C3_634826273038 === "Y") {
            this.props.history.push(
              `/interview-detail-new/${interviewDetail.interviewId}`
            );
          } else {
            this.props.history.push(
              `/interview_detail/${interviewDetail.interviewId}`
            );
          }
        }}
      >
        <div>
          <div className="position_name">{interviewDetail.job}</div>
          <div className="salary">{interviewDetail.salary}/月</div>
        </div>
        <div style={{ textAlign: "right", display: "flex" }}>
          <div style={{}}>
            <div className="status passed">
              {interviewDetail.C3_617728767339}
            </div>
            <div className="date">{interviewDetail.interviewTime}</div>
          </div>
          <div className="arrow_icon">
            <Icon type="right" color="#C7C7CC" />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="my_interviews">
        <GoBack goBack={this.goBack} />
        {!this.state.loading && (
          <div className="interviews_list">
            {this.state.myInterviews.length ? (
              this.state.myInterviews.map(item => {
                return this.renderCard(item);
              })
            ) : (
              <Result
                img={
                  <Icon
                    type="cross-circle-o"
                    className="spe"
                    style={{ fill: "#F13642" }}
                  />
                }
                title="暂无面试记录"
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withAuth(MyInterviews);
